import React, { useEffect, useState } from "react";
import { apiCreateNewModel } from "api/apiAiModels";

import { App, Divider, Form } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import SelectedSectorsChart from "components/ModelCreation/SelectedSectorsChart";
import { apiCheckAiSymbol } from "api/apiAiResults";
import CreateModelForm from "./CreateModelForm";
import ModelCreationStatus from "./ModelCreationStatus";
import { modelTrainingChannel } from "utils/constants";

const ModelCreation = () => {
  const symbolsList = useSelector((state) => state.main.symbolsList);
  const symbolsDict = useSelector((state) => state.main.symbolsDict);
  const { message } = App.useApp();

  const [form] = Form.useForm();
  const [isPending, setIsPending] = useState(false);
  const [requestStatus, setRequestStatus] = useState("");
  const [isPredicting, setIsPredicting] = useState(false);
  const [modelData, setModelData] = useState(null);

  const convertIndicatorsNames = (indicators) => {
    const result = {};
    Object.entries(indicators).forEach(([indicatorName, indexedValues]) => {
      if (!indexedValues) return;
      Object.values(indexedValues).forEach((indicatorValue) => {
        if (indicatorValue === undefined || indicatorValue === null) return;
        let convertedName;
        if (typeof indicatorValue === "object") {
          const nestedValues = Object.values(indicatorValue).join("_");
          convertedName = `${indicatorName}_${nestedValues}`;
        } else {
          convertedName = `${indicatorName}_${indicatorValue}`;
        }
        result[convertedName] = indicatorValue;
      });
    });
    return result;
  };

  const handleCreateModel = async (values) => {
    const indicators = form.getFieldValue("indicators");
    if (!indicators || Object.keys(indicators).length === 0) {
      return;
    }
    const { leads, dates, name, percToGain, days, modelType } = values;
    setIsPending(true);
    setRequestStatus("");
    try {
      const response = await apiCreateNewModel({
        leads,
        name,
        percToGain,
        days,
        indicators: convertIndicatorsNames(indicators),
        startDate: dates[0].format("YYYY-MM-DD"),
        endDate: dates[1].format("YYYY-MM-DD"),
        modelType,
        channel: modelTrainingChannel,
        resolution: values.resolution || "1d",
        evalOnly: values.evalOnly,
        n_estimators: values.n_estimators,
        max_depth: values.max_depth,
      });
      if (response.error) {
        setRequestStatus("error");
        message.error("Error creating model!");
        return;
      }
      setModelData(response);
      setRequestStatus(response._id);
      message.success("Model created successfully!");
    } catch (err) {
      setRequestStatus("error");
    }
    setIsPending(false);
  };

  const predictAllModelHistory = async () => {
    setIsPredicting(true);
    const values = form.getFieldsValue();
    const formData = {
      symbol: symbolsList.map((item) => item.ticker),
      modelId: requestStatus,
      startDate: dayjs("2000-01-01").format("YYYY-MM-DD"),
      endDate: dayjs().add(1, "d").format("YYYY-MM-DD"),
      percToGain: values.percToGain,
      days: values.days,
      indicators: convertIndicatorsNames(form.getFieldValue("indicators") || {}),
      channel: modelTrainingChannel,
      resolution: values.resolution || "1d",
    };
    try {
      await apiCheckAiSymbol(formData);
      setIsPredicting(false);
      setRequestStatus("success");
      message.success("Model Predicted successfully!");
      // form.resetFields();
    } catch (err) {}
  };

  useEffect(() => {
    document.title = "Create Model | Dindicator Dashboard";
  }, []);

  return (
    <>
      <Divider orientation="left">Create New Model</Divider>

      <div className="cards-wrapper">
        <CreateModelForm
          form={form}
          isPending={isPending}
          isPredicting={isPredicting}
          handleCreateModel={handleCreateModel}
          symbolsList={symbolsList}
        />
      </div>
      <div className="cards-wrapper">
        <ModelCreationStatus
          requestStatus={requestStatus}
          setRequestStatus={setRequestStatus}
          isPredicting={isPredicting}
          predictAllModelHistory={predictAllModelHistory}
          modelData={modelData}
          setModelData={setModelData}
        />
        <SelectedSectorsChart symbolsDict={symbolsDict} form={form} />
      </div>
    </>
  );
};

export default ModelCreation;
